<template>
    <div>
        <div class="table-a">
            <div class="table-name">
                <h3 class="ico_table_name">기본정보</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="11%">
                    <col width="19%">
                    <col width="10%">
                    <col width="20%">
                    <col width="10%">
                    <col width="20%">
                </colgroup>
                <tbody>
                <tr>
                    <th>방문번호</th>
                    <td>{{form.visitNo}}</td>
                    <th>진행상태</th>
                    <td>{{form.visitStatNm}}</td>
                    <th>접수유형</th>
                    <td>{{form.visitTypeNm}}</td>
                </tr>
                <tr>
                    <th>방문사업장</th>
                    <td>{{form.businessAreaNm}}</td>
                    <th>방문부서</th>
                    <td>{{form.visitDeptNm}}</td>
                    <th>피방문자</th>
                    <td>{{form.visitEmpNm}}</td>
                </tr>
                <tr id="Place">
                    <th :class="{ 'tp-a': !isReadonly }">출입장소</th>
                    <td colspan="5" v-if="!isReadonly">
                        <ul style="list-style: none;">
                            <li v-for="(item,i) in visitPlaceCds" :key="i" style="float: left; padding-right: 2px">
                                <input type="checkbox" :id="item.key" @change="applyCheck('Place')" :disabled="isReadonly" :value="item.value" :checked="item.checked"/><label :for="item.key">{{item.value}}</label>
                            </li>
                        </ul>
                    </td>
                    <td colspan="5" v-else>
                        {{ visitPlaceNms }}
                    </td>
                </tr>
                <tr id="Etc" v-if="this.visitEtcYn">
                  <th :class="{ 'tp-a': !isReadonly }">기타사항</th>
                  <td colspan="5" v-if="!isReadonly">
                    <ul style="list-style: none;">
                      <li v-for="(item,i) in visitEtcCds" :key="i" style="float: left; padding-right: 2px">
                        <input type="checkbox" :id="item.key" @change="applyCheck('Etc')" :disabled="isReadonly" :value="item.value" :checked="item.checked"/><label :for="item.key">{{item.value}}</label>
                      </li>
                    </ul>
                  </td>
                  <td colspan="5" v-else>
                    {{ visitEtcNms }}
                  </td>
                </tr>
                <tr v-if="form.apprRsn || !isReadonly">
                    <th :class="{ 'tp-a': !isReadonly }">피방문자 의견</th>
                    <td colspan="5" v-if="!isReadonly">
                        <textarea placeholder="상신시 기타의견 있을시 작성해주세요" v-model="form.apprRsn" :disabled="isReadonly"></textarea>
                    </td>
                    <td colspan="5" v-else>
                        {{ form.apprRsn }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="table-a">
            <div class="table-name">
                <h3 class="ico_table_name">신청자정보</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="11%">
                    <col width="19%">
                    <col width="10%">
                    <col width="20%">
                    <col width="10%">
                    <col width="20%">
                </colgroup>
                <tbody>
                <tr>
                    <th>신청자명</th>
                    <td>{{form.visitorFirstNm}}</td>
                    <th>전화번호</th>
                    <td>{{form.visitorFirstMobile}}</td>
                    <th>방문목적</th>
                    <td>{{form.purposeNm}}</td>
                </tr>
                <tr>
                    <th>소속회사</th>
                    <td>{{form.visitorComp}}</td>
                    <th>회사주소</th>
                    <td colspan="3">{{form.visitorCompAddr}}</td>
                </tr>
                <tr>
                    <th>방문시작일</th>
                    <td>{{form.staYmd}} / {{form.staTime}}</td>
                    <th>방문종료일</th>
                    <td colspan="3">{{form.endYmd}} / {{form.endTime}}</td>
                </tr>
                <tr>
                    <th>상세내용</th>
                    <td colspan="5"><span style="white-space: pre-line;">{{ form.content }}</span></td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="etcInfoList.length!==0 || isEditable" class="table-a fixed-th">
            <div class="table-name">
                <h3 class="ico_table_name">보안실 특이사항</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="12%">
                    <col width="81%">
                    <col width="7%">
                </colgroup>
                <tbody>
                <tr v-for="(item, index) in this.etcInfoList">
                    <th>{{item.empNm}}</th>
                    <td colspan="2">{{item.etcInfo}}<span style="color: #9a9a9a">&nbsp;&nbsp;&nbsp;&nbsp;[{{item.regDtm}}]</span></td>
                </tr>
                <tr v-if="isEditable">
                    <th class="tp-a">특이사항</th>
                    <td>
                        <textarea placeholder="특이사항이 있을 시 입력해주세요" v-model="form.etcInfo"></textarea>
                    </td>
                    <td style="border-left: none;">
                        <button type="button" class="btn btn-etc" style="top: 13px;" @click="save"><span style="color:black; font-size: 13px">저장</span></button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="form.cancelRsn" class="table-a fixed-th">
            <div class="table-name">
                <h3 class="ico_table_name">방문취소 사유</h3>
            </div>
            <table class="table">
                <colgroup>
                    <col width="11%">
                    <col width="89%">
                </colgroup>
                <tbody>
                <tr>
                    <th>담당자 의견</th>
                    <td>
                        {{ form.cancelRsn }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';
    import _ from "lodash";

    export default {
        name: 'VistBase',
        props: {
            'value': {
                type: Object,
                required: true
            },
            status: {
                type: Object,
                required: false,
                default () {
                    return {
                        memento: [],
                        readonly: false
                    }
                }
            },
            readonly: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        mixins: [mixin, mixinSlip],
        data() {
            return {
                form: {
                    //방문번호
                    visitNo: '',
                    //진행상태
                    visitStatNm : '',
                    //진행코드
                    visitStatCd : '',
                    //방문유형
                    visitTypeNm : '',
                    //방문유형명
                    visitTypeCd : '',
                    //회사코드
                    compCd: '',
                    //사업장정보
                    businessAreaCd: '',
                    businessAreaNm: '',
                    //방문부서
                    visitDeptNm: '',
                    //피방문자id
                    visitEmp: '',
                    //피방문자명
                    visitEmpNm: '',
                    //방문장소
                    visitPlaceCd : '',
                    //방문장소
                    visitEtcCd : '',
                    //visitPlaceNm : '',
                    visitorFirstNm: '',
                    visitorFirstMobile: '',
                    //방문자 회사
                    visitorComp: '',
                    //방문자 회사 주소
                    visitorCompAddr: '',
                    //방문시작일
                    staYmd: '',
                    //시작시간
                    staTime: '',
                    //방문종료일
                    endYmd: '',
                    //종료시간
                    endTime: '',
                    //방문목적
                    purposeNm: '',
                    //상세정보
                    content: '',
                    //비고
                    apprRsn: '',
                    //취소사유
                    cancelRsn: '',
                    //보안실 특이사항
                    etcInfo: '',
                },
                visitPlaceList:[],
                visitPlaceCds: [],
                visitPlaceNms: '',
                visitEtcList:[],
                visitEtcCds: [],
                visitEtcNms: '',
                authority: '',
                etcInfoList: '',
                visitEtcYn: '',
            };
        },
        computed: {
            isReadonly() {
                return this.status.readonly || this.readonly || this.$store.state.loginInfo.loginId !== this.form.visitEmp
            },
            isEditable() {
                return this.form.visitStatCd === '50' && (this.authority==='ADMIN' || this.authority==='SECURITY' || this.authority==='MG_VISITOR')
            }
        },
        methods: {
            save() {
                if(!this.form.etcInfo){
                    this.$swal({type: 'warning', text: '특이사항을 입력해주세요.'})
                    return false
                }

                this.$swal({
                    type: 'info',
                    text: `특이사항을 저장합니다. 계속 하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$store.commit('loading')
                        this.$http.post(`/api/visit/save/etcInfo`, {
                            visitNo : this.form.visitNo,
                            etcInfo : this.form.etcInfo
                        }).then((response) => {
                            this.$store.commit('finish')
                            this.$swal({ type: 'info', text: '완료되었습니다.'
                            }).then((result) => {
                                this.form.etcInfo=''
                                this.getEtcInfo()
                            })
                        }).catch((e) => {
                            this.$store.commit('finish')
                            console.error(e);
                        })
                    }
                })
            },
            getEtcInfo() {
                this.$http.post(`/api/visit/etc/list`, {
                    visitNo : this.form.visitNo
                }).then(response => {
                    if (response.data)
                        this.etcInfoList = response.data;
                })
            },
            getVisitPlaceCdsCombo(compCd, businessAreaCd) {
                this.$http.get(`/api/code/combo`, { params: { compCd: compCd, groupCd: "VISIT_PLACE_CD", remark1: businessAreaCd} })
                    .then(response => {
                        this.visitPlaceCds = response.data;
                    });
            },
            getVisitEtcCdsCombo(compCd, businessAreaCd) {
              this.$http.get(`/api/code/combo`, { params: { compCd: compCd, groupCd: "VISIT_ETC_CD", remark1: businessAreaCd} })
                  .then(response => {
                    this.visitEtcCds = response.data;
                  });
            },
            applyCheck(id){
              /* 체크된 데이터 가져오기*/
              let test1 = document.getElementById(id);
              let checkBoxes = test1.getElementsByTagName("input");

              let result = ''
              for (let c = 0; c < checkBoxes.length; c++) {
                if (checkBoxes[c].checked) {
                  let row = checkBoxes[c];
                  result += row.id +','
                }
              }
              result = result.trim().substr(0,result.length-1)
              eval("this.form.visit" + id + "Cd = result");
            },
            getFuncUsed() {
                this.$http.get(`/api/func/getFuncUse`, {params: {funcCd: "VISIT_ETC_YN"}})
                    .then(response => {
                        this.visitEtcYn = response.data[0].adminFuncCd === 'Y'? true : false
                    })
            }
        },
        mounted() {
            this.getFuncUsed();
            this.authority = this.$store.state.loginInfo.authorities[0].roleCd;
        },
        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.form = value

                }
            },
            'visitPlaceCds' : {
                immediate: false,
                deep: false,
                handler(value) {
                    this.visitPlaceList = String(this.form.visitPlaceCd).split(",")
                    this.visitPlaceNms = ''
                    for(let i=0; i<this.visitPlaceCds.length; i++){
                        for(let j=0; j<this.visitPlaceList.length; j++){
                            if(this.visitPlaceCds[i].key == this.visitPlaceList[j]){
                                this.visitPlaceCds[i].checked = true
                                this.visitPlaceNms += this.visitPlaceCds[i].value + ', '
                            }
                        }
                    }
                    this.visitPlaceNms = this.visitPlaceNms.trim().substr(0,this.visitPlaceNms.length-2)
                }
            },
            'visitEtcCds' : {
              immediate: false,
              deep: false,
              handler(value) {
                this.visitEtcList = String(this.form.visitEtcCd).split(",")
                this.visitEtcNms = ''
                for(let i=0; i<this.visitEtcCds.length; i++){
                  for(let j=0; j<this.visitEtcList.length; j++){
                    if(this.visitEtcCds[i].key == this.visitEtcList[j]){
                      this.visitEtcCds[i].checked = true
                      this.visitEtcNms += this.visitEtcCds[i].value + ', '
                    }
                  }
                }
                this.visitEtcNms = this.visitEtcNms.trim().substr(0,this.visitEtcNms.length-2)
              }
            },
            'form.businessAreaCd' : {
                immediate: true,
                deep: true,
                handler(value) {
                    if(value !== undefined) {
                        this.getVisitPlaceCdsCombo(this.form.compCd, value)
                        this.getVisitEtcCdsCombo(this.form.compCd, value)
                    }
                }
            },
            'form.visitNo' : {
                immediate: true,
                deep: true,
                handler(value) {
                    this.getEtcInfo()
                }
            },
        }
    };
</script>

<style scoped>
    .table-a  {
        margin-bottom: 20px;
    }

    .table-area table {
        table-layout: fixed;
    }

    .table-area table th {
        width: 150px;
    }

    .table-area .table-a table tr td {
        width: calc(33.33% - 150px);
        vertical-align: middle;
    }

    :global(th) {
        vertical-align: middle !important;
    }

    :global(td) {
        vertical-align: middle !important;
    }

    table tbody tr th {
        padding: 6px 26px;
        color: #222;
        height: 37px;
    }

    .table-area .table-a table th.tp-a:before {
        content: "*";
        position: absolute;
        left: 11px;
        top: calc(50% + 2px);
        transform: translateY(-50%);
    }
    .btn {
        background: #646464;
        color: #fff;
        padding: 7px 18px;
        border-radius: 3px;
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-55%, -30%);
        font-family: 'NotoM';
        font-size: 15px;
    }
    .btn.btn-etc {
        background: #ffffff;
        border: 1px solid;
        color: rgba(10, 10, 10, 0.42);
    }
</style>

